import React from 'react';

const logos = [
  { name: 'Bloomable', src: require('../assets/img/quotation/bloomable.svg').default },
  { name: 'Kagiso', src: require('../assets/img/quotation/kagiso.svg').default },
  { name: 'Juta', src: require('../assets/img/quotation/juta.svg').default },
  { name: 'Mérieux NutriSciences', src: require('../assets/img/quotation/merieux.svg').default },
  { name: 'Paycorp', src: require('../assets/img/quotation/paycorp.svg').default },
  { name: 'AVSApro', src: require('../assets/img/quotation/avsapro.svg').default },
];

const TrustedBySection: React.FC = () => {
  return (
    <section className="py-12 lg:py-16 bg-white">
      <div className="max-w-content mx-auto px-6 text-center">
        <h3 className="font-exo font-bold text-ebony-clay text-xl lg:text-2xl tracking-[1.2px] leading-normal mb-8">
          Trusted By
        </h3>
      </div>

      <div className="tb-viewport">
        <div className="tb-track">
          {[...logos, ...logos].map((logo, i) => (
            <div className="tb-item" key={i} aria-hidden={i >= logos.length}>
              <img src={logo.src} alt={logo.name} />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .tb-viewport {
          width: 100%;
          overflow: hidden;
          -webkit-mask-image: linear-gradient(to right, transparent, #000 7%, #000 93%, transparent);
          mask-image: linear-gradient(to right, transparent, #000 7%, #000 93%, transparent);
        }
        .tb-track {
          display: flex;
          width: max-content;
          align-items: center;
          animation: tbScroll 30s linear infinite;
        }
        .tb-viewport:hover .tb-track {
          animation-play-state: paused;
        }
        .tb-item {
          flex: 0 0 auto;
          margin-right: 3.5rem;
          display: flex;
          align-items: center;
        }
        @media (min-width: 1024px) {
          .tb-item { margin-right: 5rem; }
        }
        .tb-item img {
          height: 30px;
          width: auto;
          max-width: none;
          object-fit: contain;
        }
        @media (min-width: 1024px) {
          .tb-item img { height: 38px; }
        }
        @keyframes tbScroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .tb-track { animation: none; flex-wrap: wrap; justify-content: center; gap: 2rem 3rem; }
          .tb-viewport { -webkit-mask-image: none; mask-image: none; }
        }
      `}</style>
    </section>
  );
};

export default TrustedBySection;
